// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3SkTU","icon":"SortAdornment_icon__2yjT7","up":"SortAdornment_up__2VDh2","down":"SortAdornment_down__24-k-","active":"SortAdornment_active__1PE6k"};